import { getToken } from 'data/auth/utils'
import { EntityId } from 'entities-next/common'
import { createApiHandler, CreateApiHandlerConfig } from 'services-next/api'
import { createEntityParser } from 'utils-next/api'

import { parseApiSubspace } from './subspace.config'
import { Subspace } from './subspace.types'
import { PaginationOptions } from '../../utils-next/types'
import { PagedResult } from '../../utils/pagedResult'

export type SubspaceListFilters = {
  id?: EntityId
  userId?: EntityId
  spaceId?: EntityId
  name?: string
}

const SUBSPACES_ENDPOINT_PATH = 'admin/subspaces'

export function getApiSubspaceHandlers(customToken?: string, config: Omit<CreateApiHandlerConfig, 'baseUrl'> = {}) {
  const token = customToken || getToken() || undefined
  const transformResponse = createEntityParser(parseApiSubspace)
  const { callApi } = createApiHandler(token, { ...config, transformResponse })

  async function apiGetSubspaceList(
    filters: SubspaceListFilters,
    paginationOptions: PaginationOptions
  ): Promise<PagedResult<Subspace>> {
    const page = Number(paginationOptions.currentPage.toString()) + 1
    const config = {
      url: SUBSPACES_ENDPOINT_PATH,
      params: {
        ...filters,
        page: page,
        limit: paginationOptions.limit,
      },
    }
    return await callApi<PagedResult<Subspace>>(config)
  }

  return {
    apiGetSubspaceList,
  }
}
